import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({
    baseURL: `${API_BASE}/api/v1`,
    headers: { 'Content-Type': 'application/json' },
});

// Inject JWT token on every request
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Auto-logout on 401
api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401 && window.location.pathname.startsWith('/admin')) {
            localStorage.removeItem('token');
            window.location.href = '/admin/login';
        }
        return Promise.reject(err);
    }
);

export default api;
export { API_BASE };

export const generateCV = (recruiterId) =>
    api.post(`/recruiters/${recruiterId}/generate-cv`);
